module.exports = __webpack_public_path__ + "static/media/m_1.a8e0657e.svg";